import * as React from "react";
import { connect } from "react-redux";
import { Action, Dispatch } from "redux";
import {
  Field,
  FieldArray,
  formValueSelector,
  InjectedFormProps,
  reduxForm,
  WrappedFieldArrayProps,
} from "redux-form";
import styled from "styled-components";
import {
  customerConfig,
  pastCaseProjectConfig,
} from "../../../../../config/language/ja-JP/domain/model_text";
import {
  ConstBorderRound,
  ConstBreakPoint,
  ConstColor,
} from "../../../../../config/styles_const/styles_const";
import { Customer } from "../../../../../domain/model/customer";
import {
  PastCaseProject,
  WorkCommunication,
  WorkDetail,
  WorkLocation,
} from "../../../../../domain/model/past_case_project";
import { Occupation } from "../../../../../domain/model/project";
import { entity } from "../../../../../infra/api/rpc/api";
import {
  createNoRequiredOptionItem,
  createSelectItem,
} from "../../../../../util/select_option_function";
import * as Validator from "../../../../../util/validation";
import BtnBorderMiddle from "../../../../common/atom/btn/btn_border_middle";
import BtnCorporateLarge from "../../../../common/atom/btn/btn_corporate_large";
import BtnLinkCancelSmall from "../../../../common/atom/btn/btn_link_cancel_small";
import ErrorText from "../../../../common/atom/text/error_text";
import ParagraphSup from "../../../../common/atom/text/paragraph_sup";
import DatepickerWrapper from "../../../../common/atom/wrapper/datepicker_wrapper/datepicker_wrapper";
import MonthDaysWrapper from "../../../../common/atom/wrapper/datepicker_wrapper/month_days_wrapper";
import YearWrapper from "../../../../common/atom/wrapper/datepicker_wrapper/year_wrapper";
import FormFieldWrapper from "../../../../common/atom/wrapper/form_field_wrapper";
import CancelButtonWrapper from "../../../../common/atom/wrapper/submit_btn_wrapper/cancel_button_wrapper";
import SubmitButtonWrapper from "../../../../common/atom/wrapper/submit_btn_wrapper/submit_btn_wrapper";
import SubmitErrorTextWrapper from "../../../../common/atom/wrapper/submit_error_text_wrapper";
import FormGroupInputConnectRf from "../../../../common/molecular/form_group/form_group_input_connect_rf";
import FormGroupSelectConnectRf from "../../../../common/molecular/form_group/form_group_select_connect_rf";
import FormGroupTextareaConnectRf from "../../../../common/molecular/form_group/form_group_textarea_connect_rf";
import { AppState } from "../../../../store/app_state";

const validate = (values: any) => {
  const errors: any = {};

  return errors;
};

interface IRenderPastCaseProjectsProps
  extends WrappedFieldArrayProps<IMyFieldValue> {
  change: any;
}

const renderPastCaseProjects: React.FC<IRenderPastCaseProjectsProps> = (
  props
) => {
  const { fields, meta } = props;

  return (
    <React.Fragment>
      <PastCaseProjectTitleWrapper id="pastCaseProject">
        <ParagraphSup bold={true}>
          登録企業に契約の具体的なイメージを持ってもらうために、あなたの過去の案件内容を2つ教えてください。
        </ParagraphSup>
      </PastCaseProjectTitleWrapper>

      {fields.map((pastCaseProject: any, index: number) => {
        return (
          <ItemWrapper key={index}>
            <RenderPastCaseProject
              pastCaseProject={pastCaseProject}
              index={index}
              key={index}
            />
          </ItemWrapper>
        );
      })}
      {fields.length < 2 && (
        <PastCaseProjectBtnWrapper>
          <BtnBorderMiddle
            type="button"
            onClick={fieldsPush({ fields, meta: { error: meta.error } })}
          >
            案件例を追加
          </BtnBorderMiddle>
        </PastCaseProjectBtnWrapper>
      )}
      {meta.error && <li className="error">{meta.error}</li>}
    </React.Fragment>
  );
};

interface IRenderPastCaseProject {
  pastCaseProject: any;
  index: number;
}

const RenderPastCaseProject: React.FC<IRenderPastCaseProject> = (props) => {
  const { pastCaseProject, index } = props;

  return (
    <React.Fragment>
      <PastCaseProjectLabel>
        <ParagraphSup bold={true}>{index + 1}つ目の案件</ParagraphSup>
      </PastCaseProjectLabel>

      <FormFieldWrapper>
        <Field
          name={`${pastCaseProject}.title`}
          type="text"
          component={FormGroupInputConnectRf}
          label="タイトル"
          placeholder="例）採用支援の案件"
          validate={[Validator.title]}
        />
      </FormFieldWrapper>

      <FormFieldWrapper>
        <ParagraphSup bold={true}>打ち合わせについて</ParagraphSup>

        <div
          style={{
            display: "flex",
            alignItems: "end",
            marginTop: 10,
            marginBottom: 20,
          }}
        >
          <div style={{ fontSize: "12px", marginRight: "10px" }}>約</div>
          <div style={{ width: "100px", marginRight: "10px" }}>
            <Field
              name={`${pastCaseProject}.meetingNum`}
              component={FormGroupInputConnectRf}
              type="number"
              validate={[]}
            />
          </div>
          <div style={{ fontSize: "12px" }}>回/</div>
          <div
            style={{
              width: "100px",
              marginRight: "10px",
              marginLeft: "10px",
            }}
          >
            <Field
              name={`${pastCaseProject}.meetingInterval`}
              component={FormGroupSelectConnectRf}
              type="text"
              validate={[]}
            >
              <option value={entity.PastCaseProject.Interval.Interval_Unknown}>
                ~~
              </option>
              <option value={entity.PastCaseProject.Interval.Interval_Month}>
                月
              </option>
              <option value={entity.PastCaseProject.Interval.Interval_Week}>
                週
              </option>
            </Field>
          </div>
          <div style={{ fontSize: "12px" }}>の頻度で、1回あたり約</div>
          <div
            style={{
              width: "100px",
              marginRight: "10px",
              marginLeft: "10px",
            }}
          >
            <Field
              name={`${pastCaseProject}.meetingMinutes`}
              component={FormGroupInputConnectRf}
              type="number"
              validate={[]}
            />
          </div>
          <div style={{ fontSize: "12px" }}>分の打ち合わせ</div>
        </div>

        <ParagraphSup bold={true}>実稼働について</ParagraphSup>

        <div
          style={{
            display: "flex",
            alignItems: "end",
            marginTop: 10,
            marginBottom: 20,
          }}
        >
          <div style={{ fontSize: "12px", marginRight: "10px" }}>約</div>
          <div style={{ width: "100px", marginRight: "10px" }}>
            <Field
              name={`${pastCaseProject}.workingHour`}
              component={FormGroupInputConnectRf}
              type="number"
              validate={[]}
            />
          </div>
          <div style={{ fontSize: "12px" }}>時間/</div>
          <div
            style={{
              width: "100px",
              marginRight: "10px",
              marginLeft: "10px",
            }}
          >
            <Field
              name={`${pastCaseProject}.workingInterval`}
              component={FormGroupSelectConnectRf}
              type="text"
              validate={[]}
            >
              <option value={entity.PastCaseProject.Interval.Interval_Unknown}>
                ~~
              </option>
              <option value={entity.PastCaseProject.Interval.Interval_Month}>
                月
              </option>
              <option value={entity.PastCaseProject.Interval.Interval_Week}>
                週
              </option>
            </Field>
          </div>
          <div style={{ fontSize: "12px" }}>の実稼働</div>
        </div>

        <ParagraphSup bold={true}>報酬について</ParagraphSup>

        <div style={{ display: "flex", alignItems: "end", marginTop: 10 }}>
          <div style={{ width: "100px", marginRight: "10px" }}>
            <Field
              name={`${pastCaseProject}.feePerMonth`}
              component={FormGroupInputConnectRf}
              type="number"
              validate={[]}
            />
          </div>
          <div style={{ fontSize: "12px" }}>万円/月の契約</div>
        </div>
      </FormFieldWrapper>
      <FormFieldWrapper>
        <DatepickerWrapper>
          <MonthDaysWrapper>
            <Field
              label={pastCaseProjectConfig.workLocation}
              name={`${pastCaseProject}.workLocation`}
              component={FormGroupSelectConnectRf}
              type="text"
              validate={[]}
            >
              {createSelectItem(true, pastCaseProjectConfig.workLocationList)}
            </Field>
          </MonthDaysWrapper>

          <YearWrapper>
            <Field
              label={pastCaseProjectConfig.workCommunication}
              name={`${pastCaseProject}.workCommunication`}
              component={FormGroupSelectConnectRf}
              type="text"
              validate={[]}
            >
              {createSelectItem(
                true,
                pastCaseProjectConfig.workCommunicationList
              )}
            </Field>
          </YearWrapper>

          <YearWrapper>
            <Field
              label={pastCaseProjectConfig.workDetail}
              name={`${pastCaseProject}.workDetail`}
              component={FormGroupSelectConnectRf}
              type="text"
              validate={[]}
            >
              {createSelectItem(true, pastCaseProjectConfig.workDetailList)}
            </Field>
          </YearWrapper>
        </DatepickerWrapper>
      </FormFieldWrapper>

      <FormFieldWrapper>
        <Field
          name={`${pastCaseProject}.achievementReward`}
          type="text"
          component={FormGroupTextareaConnectRf}
          label="成果報酬がありの場合の、金額と条件"
          placeholder="例）採用目標を設定しており、予算内でその目標を達成した場合、追加の成果報酬として150万円を頂戴する契約でした。"
          rows={3}
          validate={[Validator.achievementReward]}
        />
      </FormFieldWrapper>
    </React.Fragment>
  );
};

interface IMyFieldValue {
  num: number;
  pastCaseProject: PastCaseProject;
}

const fieldsPush = (p: { fields: any; meta: { error: any } }) => () => {
  p.fields.push();
};

const fieldsRemove =
  (p: { fields: any; meta: { error: any } }, index: number) => () => {
    p.fields.remove(index);
  };

interface IStateProps {
  initialValues:
    | {
        customer: Customer | null;
        jobCareers: Array<{
          companyName: string;
          description: string;
          occupations: Occupation[];
          startedAt: string;
          endedAt: string;
        }>;
        pastCaseProjects: Array<{
          title: string;
          daysPerMonth: number;
          hourtsPerMonth: number;
          rewardPerMonth: number;
          workLocation: WorkLocation;
          workCommunication: WorkCommunication;
          workDetail: WorkDetail;
          achievementReward: string;
        }>;
        tags_1: string[];
        tags_7: string[];
        tags_5: string[];
        tags_3: string[];
        tags_4: string[];
        tags_6: string[];
      }
    | undefined;
  formValues: any;
}

interface IProps extends IStateProps {}

interface IState {}

class PastProjectEditForm extends React.Component<
  IProps & InjectedFormProps<{}, IProps>,
  IState
> {
  constructor(props: IProps & InjectedFormProps<{}, IProps>) {
    super(props);

    this.state = {};
  }

  public componentWillUpdate(nextProps: any, nextState: any): void {
    // 更新実行後の初期化処理
    if (
      this.props.formValues &&
      this.props.initialValues.customer &&
      nextProps.initialValues.customer.gsIconURL !==
        this.props.initialValues.customer.gsIconURL
    ) {
      URL.revokeObjectURL(this.props.formValues.preview);
    }
  }

  public componentWillUnmount(): void {
    // Make sure to revoke the data uris to avoid memory leaks
    if (this.props.formValues != null) {
      URL.revokeObjectURL(this.props.formValues.preview);
    }
  }

  public render(): JSX.Element {
    const { anyTouched, invalid, handleSubmit, pristine, submitting, change } =
      this.props;

    const customer: Customer | null = this.props.initialValues
      ? this.props.initialValues.customer
      : null;

    if (!customer) {
      return <div />;
    }

    let res: JSX.Element;

    // 編集ページ
    res = (
      <React.Fragment>
        <form name="PastProjectEditForm" onSubmit={handleSubmit}>
          <FormFieldWrapper id="workingFrequency">
            <Field
              label={customerConfig.workingFrequency}
              name="customer.workingFrequency"
              component={FormGroupSelectConnectRf}
              type="text"
            >
              {createNoRequiredOptionItem(customerConfig.workingFrequencyList)}
            </Field>
          </FormFieldWrapper>
          <FormFieldWrapper id="workIntention">
            <Field
              label={customerConfig.workIntention}
              name="customer.workIntention"
              component={FormGroupSelectConnectRf}
              type="text"
            >
              {createSelectItem(true, customerConfig.workIntentionList)}
            </Field>
          </FormFieldWrapper>
          <FormFieldWrapper>
            <Field
              label={customerConfig.requestedFee}
              name="customer.requestedFee"
              component={FormGroupSelectConnectRf}
              type="text"
            >
              {createNoRequiredOptionItem(customerConfig.requestedFeeList)}
            </Field>
          </FormFieldWrapper>
          <FormFieldWrapper>
            <Field
              label={customerConfig.fullTimePossibility}
              name="customer.fullTimePossibility"
              component={FormGroupSelectConnectRf}
              type="text"
            >
              {createSelectItem(true, customerConfig.fullTimePossibilityList)}
            </Field>
          </FormFieldWrapper>
          <FormFieldWrapper>
            <Field
              label={customerConfig.brokerageProjectPossibility}
              name="customer.brokerageProjectPossibility"
              component={FormGroupSelectConnectRf}
              type="text"
            >
              {createSelectItem(
                true,
                customerConfig.brokerageProjectPossibilityList
              )}
            </Field>
          </FormFieldWrapper>
          <FormFieldWrapper>
            <Field
              label={customerConfig.requestedCondition}
              placeholder="入力してください"
              name="customer.requestedCondition"
              component={FormGroupTextareaConnectRf}
              validate={[Validator.requestedCondition]}
            />
          </FormFieldWrapper>

          <FieldArray<IRenderPastCaseProjectsProps>
            name={`pastCaseProjects`}
            component={renderPastCaseProjects}
          />
          {anyTouched && invalid && (
            <SubmitErrorTextWrapper>
              <ErrorText>入力を完了してください</ErrorText>
            </SubmitErrorTextWrapper>
          )}

          <SubmitButtonWrapper>
            <CancelButtonWrapper>
              <BtnLinkCancelSmall to="/customer/mypage/customer">
                キャンセル
              </BtnLinkCancelSmall>
            </CancelButtonWrapper>
            <BtnCorporateLarge
              name="PastProjectEditForm-submit"
              type="submit"
              widthSize="200px"
              disabled={pristine || submitting || invalid}
            >
              保存
            </BtnCorporateLarge>
          </SubmitButtonWrapper>
        </form>
      </React.Fragment>
    );

    return res;
  }
}

const selector = formValueSelector("PastProjectEditForm");

const mapStateToProps = (state: AppState) => {
  return {
    formValues: selector(state, ""),
  };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
  return {};
};

export default reduxForm({
  form: "PastProjectEditForm",
  validate,
})(connect(mapStateToProps, mapDispatchToProps)(PastProjectEditForm));

const PastCaseProjectLabel = styled.div`
  margin-bottom: 15px;
`;

const ConditionsText = styled.div`
  padding-top: 22px;
`;

const ConditionsFieldWrapper = styled.div`
  width: 120px;
  margin-left: 15px;
  margin-right: 10px;
`;

const ItemWrapper = styled.div`
  padding: 20px;
  margin: 20px 0;
  background: #fefcf7;

  border: 1px solid ${ConstColor.LightGray};
  border-radius: ${ConstBorderRound.CornerRoundAll};
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    padding: 30px;
  }
`;

const PastCaseProjectTitleWrapper = styled.div`
  margin: 20px 0;
`;

const PastCaseProjectBtnWrapper = styled.div`
  margin-bottom: 20px;
`;



// WEBPACK FOOTER //
// ./src/presentation/component/customer/mypage/edit/past_project_edit_form.tsx